import getCutOrder from "@/lib/data-service/default/web_common_tourCutOrder_reservePageOrderInfo";

export default {
  data() {
    return {
      navList: ["首页", "出境产品", "产品详情", "产品预定"],
      navLink: 2,
      detail: {}
    };
  },
  created() {
    this._getDetail();
  },
  methods: {
    _getDetail() {
      let orderNo = this.$route.query.orderNo;
      getCutOrder({ cutOrderNo: orderNo }).then(res => {
        res.code == this.SUCCESS_CODE ? (this.detail = res.orderResult) : "";
      });
    }
  }
};
